<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <td
        data-slot="table-cell"
        :class="
            cn(
                'px-2 py-2.75 align-middle text-xs whitespace-nowrap [&:has([data-action])]:py-1 [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[1px]',
                props.class,
            )
        "
    >
        <slot />
    </td>
</template>
